import { Component, OnInit, Input, OnDestroy, ChangeDetectorRef, ChangeDetectionStrategy } from '@angular/core';
import { FieldType } from "@ngx-formly/core";
import { AppStateService } from "src/app/core-module/services/app-state.service";
import { CheckboxStateService } from "../../../core-module/services/state/checkbox-state.service";
import { DimmingInterfaceStateService } from "../../../core-module/services/state/dimming-interface-state.service";
const feature12nc = "feature12Nc";
const lineswitch = "lineswitch-";
const codedMains = "codedmains-";
const lineSwitchConst = "LineSwitch";
const overrideInterfaceConst = "OverrideInterface";
const codedMainsConst = "CodedMains";
const dynadimmerConst = "Dynadimmer";
@Component({
  standalone: false,
  selector: "app-dimming-interface",
  templateUrl: "./dimming-interface.component.html",
  styleUrls: ["./dimming-interface.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DimmingInterfaceComponent
  extends FieldType
  implements OnInit, OnDestroy
{
  @Input() field;
  column: LegacyAny;
  properties: LegacyAny;
  ngModelval: LegacyAny = {};
  selectedInterface = [];
  overrideInterface = [];
  dropdown = [
    "LineSwitch",
    "Amp Dim",
    "Dynadimmer",
    "DALI",
    "CodedMains",
    "ZTV",
  ];
  openDynaDimmer: boolean = false;
  overriddenInterface: LegacyAny;
  openLineSwitch: boolean;
  overridenInterfaceArray = [];
  defaultColor: boolean;
  isLineSwitchOverride: boolean;
  isCodedMainsOverride: boolean;
  defaultRestoring: boolean;
  showOverride: boolean = false;
  selectedList = [];
  OverridenList = [];
  showCodedMains: boolean = false;
  constructor(
    private ref: ChangeDetectorRef, private appState: AppStateService,
    private dimmingInterfaceSvc: DimmingInterfaceStateService,
    private checkboxState: CheckboxStateService
  ) {
    super();
  }

  setConfigurationData(value, keyVal) {
    if (value != null) {
      // Use centralized method to save feature data
      // This automatically saves to both ConfigurationData and SaveSetData
      const dimmingInterfaceObj = Object.assign({}, value);
      this.appState.setFeatureData(keyVal, dimmingInterfaceObj);
    }
  }

  private setInterfaceAndResetFlags(interfaceName: string): void {
    this.ngModelval["SelectedInterface"] = interfaceName;
    this.showOverride = false;
    this.showCodedMains = false;
    this.checkDefault();
    this.dimmingInterfaceSvc.sendDimmingInterfacedata(this.ngModelval);
    this.setConfigurationData(this.ngModelval, 'DimmingInterface');
    this.ref.markForCheck();
  }

  toggleValue(value, selectedInterface) {

    this.checkboxState.enableDimmingInterfaceCheckbox(); // Notify parent to enable dimming interface checkbox when override is toggled

    if (Boolean(value) === true) {
      if (selectedInterface === lineSwitchConst) {
        this.isLineSwitchOverride = true;
        this.ngModelval[overrideInterfaceConst].push(lineSwitchConst);
      } else if (
        selectedInterface === codedMainsConst &&
        this.ngModelval[overrideInterfaceConst].length > 0
      ) {
        this.isLineSwitchOverride = true;
        this.isCodedMainsOverride = true;
        this.ngModelval[overrideInterfaceConst].push(codedMainsConst);
      } else if (
        selectedInterface === codedMainsConst &&
        this.ngModelval[overrideInterfaceConst].length === 0
      ) {
        this.isLineSwitchOverride = false;
        this.isCodedMainsOverride = true;
        this.ngModelval[overrideInterfaceConst].push(codedMainsConst);
      }
      const sortedData = this.ngModelval[overrideInterfaceConst].sort();
      this.ngModelval[overrideInterfaceConst] = sortedData;
      this.dimmingInterfaceSvc.sendDimmingInterfacedata(this.ngModelval);
      this.setConfigurationData(this.ngModelval, 'DimmingInterface');
    } else if (Boolean(value) === false) {
      if (selectedInterface === lineSwitchConst) {
        this.isLineSwitchOverride = false;
        if (this.ngModelval[overrideInterfaceConst].length === 0) {
          this.ngModelval[overrideInterfaceConst] = [];
        } else {
          const index =
            this.ngModelval[overrideInterfaceConst].indexOf(lineSwitchConst);
          if (index > -1) {
            this.ngModelval[overrideInterfaceConst].splice(index, 1);
          }
        }
      } else if (selectedInterface === codedMainsConst) {
        this.isCodedMainsOverride = false;
        if (this.ngModelval[overrideInterfaceConst].length === 0) {
          this.ngModelval[overrideInterfaceConst] = [];
        } else {
          const index =
            this.ngModelval[overrideInterfaceConst].indexOf(codedMainsConst);
          if (index > -1) {
            this.ngModelval[overrideInterfaceConst].splice(index, 1);
          }
        }
      }
      const sortedData = this.ngModelval[overrideInterfaceConst].sort();
      this.ngModelval[overrideInterfaceConst] = sortedData;
      this.dimmingInterfaceSvc.sendDimmingInterfacedata(this.ngModelval);
      this.setConfigurationData(this.ngModelval, 'DimmingInterface');
    }
  }
  onChangeList(value) {
    this.isCodedMainsOverride = this.isLineSwitchOverride = false;
    const checkFeatures = this.appState.getConfigurationData();
    this.checkboxState.enableDimmingInterfaceCheckbox();
    if (value === dynadimmerConst || value === codedMainsConst) {
      if (value === codedMainsConst) {
        this.showOverride = checkFeatures[feature12nc].includes(lineswitch)
          ? true
          : false;
        this.showCodedMains = false;
      } else if (value === dynadimmerConst) {
        this.showOverride = checkFeatures[feature12nc].includes(lineswitch)
          ? true
          : false;
        this.showCodedMains = checkFeatures[feature12nc].includes(
          codedMains
        )
          ? true
          : false;
      }
      this.ref.detectChanges();
    } else {
      this.showOverride = this.showCodedMains = false;
      this.ref.detectChanges();
    }
    // if (
    //   this.OverridenList.length > 0 &&
    //   this.OverridenList.includes("LineSwitch")
    // ) {
    //   this.isLineSwitchOverrideInterface = true;
    // }else{
    //   this.isLineSwitchOverrideInterface = false;
    // }
    // if (this.OverridenList.length > 0) {
    //   this.openDynaDimmer = true;
    // } else {
    //   this.openDynaDimmer = false;
    // }
    if (
      checkFeatures[feature12nc].includes(lineswitch) ||
      checkFeatures[feature12nc].includes(codedMains)
    ) {
      this.ngModelval[overrideInterfaceConst] = [];
    }
    this.ngModelval["SelectedInterface"] = value;
    this.dimmingInterfaceSvc.sendDimmingInterfacedata(this.ngModelval);
    this.setConfigurationData(this.ngModelval, 'DimmingInterface');
    this.checkDefault();
    if (
      checkFeatures[feature12nc].includes("ztv-") &&
      checkFeatures[feature12nc].includes("dimminginterface-")
    ) {
      this.checkValidation();
    }
  }
  ngOnInit() {
    this.dimmingInterfaceSvc.getrestoreDefault.subscribe((data) => {
      if (data) {
        this.restoreDefault();
      }
    });

    this.dimmingInterfaceSvc.getDimmingValidity.subscribe((data) => {
      if (data) {
        this.checkValidation();
      }
    });
    this.column = this.field?.requiredProperties;
    this.properties = this.field?.properties ?? {};
    if (this.appState.getSelectedInterface() != null) {
      this.selectedInterface = this.appState.getSelectedInterface();
    } else if (this.properties.SelectedInterface && this.properties.SelectedInterface["enum"]) {
      this.selectedInterface = this.properties.SelectedInterface["enum"];
    } else {
      this.selectedInterface = [];
    }
    this.overrideInterface =
      this.properties.OverrideInterface &&
      this.properties.OverrideInterface.items &&
      this.properties.OverrideInterface.items["enum"]
        ? this.properties.OverrideInterface.items["enum"]
        : [];
    const newSupportedIntf: string[] = [];
    const selectedInftCnt = this.selectedInterface.length;
    for (let index = 0; index < selectedInftCnt; index++) {
      const element = this.selectedInterface[index];
      if (
        element.toString().toUpperCase() === "LINESWITCH" ||
        element.toString().toUpperCase() === "DYNADIMMER" ||
        element.toString().toUpperCase() === "DALI" ||
        element.toString().toUpperCase() === "AMPDIM" ||
        element.toString().toUpperCase() === "CODEDMAINS" ||
        element.toString().toUpperCase() === "ZTV"
      ) {
        if (element.toString().toUpperCase() === `0-10V / 1-10V`) {
          newSupportedIntf.push("Ztv");
        } else if (element.toString() === `Coded Mains Scene Settings`) {
          newSupportedIntf.push(codedMainsConst);
        } else {
          newSupportedIntf.push(element);
        }
      }
    }
    this.selectedInterface = newSupportedIntf;
    this.appState.setSelectedInterface(this.selectedInterface);
    this.checkRequiredProperties();
    // this.overriddenInterface = this.properties.OverrideInterface.items['enum'];
    this.checkDefault();
    const checkFeatures = this.appState.getConfigurationData() ?? {};
    const featureNcList: LegacyAny[] = Array.isArray(checkFeatures[feature12nc])
      ? checkFeatures[feature12nc]
      : [];
    if (
      featureNcList.includes("ztv-") &&
      featureNcList.includes("dimminginterface-")
    ) {
      this.checkValidation();
    }
    this.dimmingInterfaceSvc.sendDimmingInterfacedata(this.ngModelval);
    if (
      featureNcList.includes("dynadimmer-") &&
      featureNcList.includes(lineswitch)
    ) {
      if (this.properties.SelectedInterface?.default === codedMainsConst ||
        this.properties.SelectedInterface?.default === dynadimmerConst
      ) {
        this.showOverride = featureNcList.includes(lineswitch)
          ? true
          : false;
        this.showCodedMains = featureNcList.includes(
          codedMains
        )
          ? true
          : false;
      }
      this.ref.detectChanges();
    }
    setTimeout(() => {
      // Use centralized method to get feature data (prioritizes SaveSetData over ConfigurationData)
      let dimminginterfaceLoaddedFetaure = null;
      const unSelectedFeat = this.appState.getUnSelectedFeatConfig();
      let isConfigEdited = false;
      let featIndex: number = 0;
      if (unSelectedFeat != null) {
        unSelectedFeat.forEach((element) => {
          if (
            (element != null) &&
            (element["featureName"] != null) &&
            element["featureName"].toString().toUpperCase() ===
              "DIMMINGINTERFACE"
          ) {
            isConfigEdited = true;
            const DimmingInterfaceEdt: LegacyAny = element["featureParameters"][0];
            const dimminginterfaceEdtVl = {
              resp: {
                DimmingInterface: DimmingInterfaceEdt,
              },
            };
            dimminginterfaceLoaddedFetaure = dimminginterfaceEdtVl;
            unSelectedFeat.splice(featIndex, 1);
            this.appState.setUnSelectedFeatConfig(unSelectedFeat);
          } else {
            featIndex++;
          }
        });
      }

      // Get feature data using centralized method (SaveSetData takes priority over ConfigurationData)
      if (!isConfigEdited) {
        const dimmingInterfaceData = this.appState.getFeatureData('DimmingInterface');
        if (dimmingInterfaceData) {
          dimminginterfaceLoaddedFetaure = {
            resp: {
              DimmingInterface: dimmingInterfaceData
            }
          };
        }
      }

      /////
      if (dimminginterfaceLoaddedFetaure) {
        if (
          dimminginterfaceLoaddedFetaure.resp &&
          dimminginterfaceLoaddedFetaure.resp.DimmingInterface &&
          dimminginterfaceLoaddedFetaure.resp.DimmingInterface
            .SelectedInterface === dynadimmerConst
        ) {
          this.ngModelval["SelectedInterface"] = dynadimmerConst;
          //this.showCodedMains = true;
          if (
            checkFeatures[feature12nc].includes(lineswitch) ||
            checkFeatures[feature12nc].includes(codedMains)
          ) {
            if (checkFeatures[feature12nc].includes(lineswitch))
              this.showOverride = true;
            if (checkFeatures[feature12nc].includes(codedMains))
              this.showCodedMains = true;
            this.ref.detectChanges();
          }
          if (
            dimminginterfaceLoaddedFetaure.resp.DimmingInterface
              .OverrideInterface
          ) {
            this.ngModelval[overrideInterfaceConst] =
              dimminginterfaceLoaddedFetaure.resp.DimmingInterface.OverrideInterface;

            // Set checkbox states based on what's in the array
            this.isLineSwitchOverride = this.ngModelval[overrideInterfaceConst].includes(lineSwitchConst);
            this.isCodedMainsOverride = this.ngModelval[overrideInterfaceConst].includes(codedMainsConst);

            this.checkDefault();
            this.dimmingInterfaceSvc.sendDimmingInterfacedata(this.ngModelval);
            this.ref.markForCheck();
          } else {
            this.ngModelval[overrideInterfaceConst] = [];
            this.isLineSwitchOverride = false;
            this.isCodedMainsOverride = false;
            this.checkDefault();
            this.dimmingInterfaceSvc.sendDimmingInterfacedata(this.ngModelval);
            this.ref.markForCheck();
          }
        }
      }
      if (dimminginterfaceLoaddedFetaure) {
        if (
          dimminginterfaceLoaddedFetaure.resp &&
          dimminginterfaceLoaddedFetaure.resp.DimmingInterface &&
          dimminginterfaceLoaddedFetaure.resp.DimmingInterface
            .SelectedInterface === codedMainsConst
        ) {
          this.ngModelval["SelectedInterface"] = codedMainsConst;
          if (checkFeatures[feature12nc].includes(lineswitch))
            this.showOverride = true;

          this.showCodedMains = false;
          this.ref.detectChanges();
          if (
            dimminginterfaceLoaddedFetaure.resp.DimmingInterface
              .OverrideInterface
          ) {
            this.ngModelval[overrideInterfaceConst] =
              dimminginterfaceLoaddedFetaure.resp.DimmingInterface.OverrideInterface;
            this.isLineSwitchOverride = this.ngModelval[overrideInterfaceConst].includes(lineSwitchConst);
          } else {
            this.ngModelval[overrideInterfaceConst] = [];
            this.isLineSwitchOverride = false;
          }
          this.checkDefault();
          this.dimmingInterfaceSvc.sendDimmingInterfacedata(this.ngModelval);
          this.ref.markForCheck();
        }
      }
      if (dimminginterfaceLoaddedFetaure) {
        if (
          dimminginterfaceLoaddedFetaure.resp &&
          dimminginterfaceLoaddedFetaure.resp.DimmingInterface &&
          dimminginterfaceLoaddedFetaure.resp.DimmingInterface
            .SelectedInterface === lineSwitchConst
        ) {
          this.setInterfaceAndResetFlags(lineSwitchConst);
        }
      }
      if (dimminginterfaceLoaddedFetaure) {
        if (
          (dimminginterfaceLoaddedFetaure.resp &&
            dimminginterfaceLoaddedFetaure.resp.DimmingInterface &&
            dimminginterfaceLoaddedFetaure.resp.DimmingInterface
              .SelectedInterface === "AmpDim") ||
          (dimminginterfaceLoaddedFetaure.resp &&
            dimminginterfaceLoaddedFetaure.resp.ampdim &&
            dimminginterfaceLoaddedFetaure.resp.DimmingInterface
              .SelectedInterface === "AmpDim")
        ) {
          this.setInterfaceAndResetFlags("AmpDim");
        }
      }
      if (dimminginterfaceLoaddedFetaure) {
        if (
          (dimminginterfaceLoaddedFetaure.resp &&
            dimminginterfaceLoaddedFetaure.resp.DimmingInterface &&
            dimminginterfaceLoaddedFetaure.resp.DimmingInterface
              .SelectedInterface === "Ztv") ||
          (dimminginterfaceLoaddedFetaure.resp &&
            dimminginterfaceLoaddedFetaure.resp.ZTV &&
            dimminginterfaceLoaddedFetaure.resp.DimmingInterface
              .SelectedInterface === "Ztv")
        ) {
          this.setInterfaceAndResetFlags("Ztv");
        }
      }
      if (dimminginterfaceLoaddedFetaure) {
        if (
          dimminginterfaceLoaddedFetaure.resp &&
          dimminginterfaceLoaddedFetaure.resp.DimmingInterface &&
          dimminginterfaceLoaddedFetaure.resp.DimmingInterface
            .SelectedInterface === "Dali"
        ) {
          this.setInterfaceAndResetFlags("Dali");
        }
      }
    }, 1000);
  }

  checkValidation() {
    const checkFeatures = this.appState.getConfigurationData();
    const obj = Object.keys(this.ngModelval).length;
    if (obj > 0) {
      /*  if (this.ngModelval["SelectedInterface"] === "Ztv") {
        if (
          this.ngModelval["SelectedInterface"] === "Ztv" &&
          checkFeatures["selectedFeaturesInfo"].includes("ztv-") &&
          checkFeatures["selectedFeaturesInfo"].includes("dimminginterface-")
        ) {
          this.dimmingInterfaceSvc.validtionOfDimming("valid");
        } else if (
          !checkFeatures["selectedFeaturesInfo"].includes("ztv-") &&
          !checkFeatures["selectedFeaturesInfo"].includes("dimminginterface-")
        ) {
          this.dimmingInterfaceSvc.validtionOfDimming("valid");
        } else {
          this.dimmingInterfaceSvc.validtionOfDimming("invalid");
          alert(
            "0-10V / 1-10V is interdependent with Dimming Interface, so please include it in Feature File"
          );
        }
      }
      // else if (
      //   this.ngModelval["SelectedInterface"] === "Dynadimmer" &&
      //   (checkFeatures["selectedFeaturesInfo"].includes("ztv-") ||
      //     checkFeatures["selectedFeaturesInfo"].includes("dimminginterface-"))
      // ) {
      //   this.dimmingInterfaceSvc.validtionOfDimming("invalid");
      // }
      else {
        this.dimmingInterfaceSvc.validtionOfDimming("valid");
      }
 */
    }
  }

  checkRequiredProperties() {
    if (!this.field?.requiredProperties || !Array.isArray(this.field.requiredProperties)) {
      return;
    }
    this.field.requiredProperties.forEach((element) => {
      if (element === "SelectedInterface") {
        if (this.properties?.SelectedInterface) {
          this.ngModelval["SelectedInterface"] =
            this.properties.SelectedInterface.default;
        }
      } else if (element === overrideInterfaceConst && this.properties?.OverrideInterface) {
        this.ngModelval[overrideInterfaceConst] =
            this.properties.OverrideInterface.default;
        //this.createCheckList(this.properties.SelectedInterface.default);
      }
    });
  }

  createCheckList(value) {
    this.OverridenList = [];
    for (let i = 0; i < this.field["allOf"].length; i++) {
      if (
        this.field["allOf"][i]["then"].properties.OverrideInterface !==
        undefined
      ) {
        for (
          let j = 0;
          j <
          this.field["allOf"][i]["then"].properties.OverrideInterface.enum
            .length;
          j++
        ) {
          if (
            this.field["allOf"][i]["then"].properties.OverrideInterface.enum[
              j
            ] === value && this.field["allOf"][i]["if"].properties.SelectedInterface.const[0]
          ) {
              this.OverridenList.push(
                this.field["allOf"][i]["if"].properties.SelectedInterface
                  .const[0]
              );
          }
        }
      }
    }
    this.ngModelval[overrideInterfaceConst] = this.OverridenList;
  }

  paramterChecked(ischecked, event) {
    if (ischecked) {
      this.overridenInterfaceArray.push(event);
    } else {
      this.overridenInterfaceArray = this.overridenInterfaceArray.filter(
        (item) => item !== event
      );
    }
    this.ngModelval[overrideInterfaceConst] = this.overridenInterfaceArray;
    this.dimmingInterfaceSvc.sendDimmingInterfacedata(this.ngModelval);
    this.setConfigurationData(this.ngModelval, 'DimmingInterface');
  }

  checkDefault() {
    this.defaultRestoring = true;
    for (const type in this.ngModelval) {
      if (type !== overrideInterfaceConst && this.properties[type] && this.ngModelval[type] !== this.properties[type]["default"]) {
          this.defaultRestoring = false;
      }
    }
    this.dimmingInterfaceSvc.sendDimmingRestoreDefault(this.defaultRestoring);
  }

  restoreDefault() {
    if (
      (this.properties &&
        this.properties.SelectedInterface &&
        this.properties.SelectedInterface.default) != null
    ) {
      this.onChangeList(this.properties.SelectedInterface.default);
    }
    this.checkValidation();
    this.dimmingInterfaceSvc.sendDimmingRestoreDefault(this.defaultRestoring);
    this.ref.markForCheck();
  }

  ngOnDestroy() {
    this.dimmingInterfaceSvc.sendDimmingRestoreDefault("");
    this.dimmingInterfaceSvc.sendDimmingDefault("");
    this.ngModelval = {};
    this.dimmingInterfaceSvc.sendDimmingInterfacedata("");
    this.dimmingInterfaceSvc.sendDimmingCheckValidation("");
    this.appState.setSelectedInterface(null);
  }
}
